<template class="container text-center">
  <div class="parent-div container text-center row g-3 justify-content-center">
    <!-- <h1 class="text-4xl font-medium text-black p-4">Grade Calculator</h1> -->
    <div class="container justify-content-center">
      <div class="col-auto">
        <input type="text" v-model="courseCode" @keyup.enter="getCourseDetails" class="sub-code" />
        <button type="submit" id="submitCourseCode" v-on:click="getCourseDetails" class="sub-button btn btn-primary m-3">
          Get Fields
        </button>
      </div>
    </div>
    <div class="container course-code display-6 p-4">
    {{ this.course_title }}
    </div>
    <!-- <ul>
      <li v-for="p in this.params" v-bind:key="p">{{ p }}</li>
    </ul> -->
    <form class="mb-3" id="paramform">
      <div v-for="p, i in params" v-bind:key="p" class="container p-4">
        <label for="{{ p }}" class="block text-gray-700 text-sm font-bold mb-2">{{ p }}</label>
        <input v-model="this.scores[i]" type="number" min="1" max="100" @keyup.enter="submitScore"
          class="form-control" />
      </div>
    </form>
    <button type="submit" id="submitCourseCode" v-on:click="submitScore"
      class="btn btn-dark">
      Submit Score
    </button>
    <h2>Total Score: {{ this.outputScore }}</h2>
  </div>
</template>

<script>
const baseURL = "https://gradecalc.api.aswn.me/api";
import axios from "axios";
export default {
  name: "gradeCalc",
  data() {
    return {
      params: [],
      courseCode: "",
      course_title: "Enter Course Code",
      scores: [],
      outputScore: 0
    };
  },
  methods: {
    getCourseDetails() {
      axios.put(baseURL, { course_code: this.courseCode }).then((res) => {
        this.params = res.data.paramDetails;
        this.scores = new Array(res.data.parameterCount).fill(0);
        this.course_title = res.data.course_name
          console.log(this.scores)
      });
    },

    submitScore() {
      axios.post(baseURL, { course_code: this.courseCode, sub_scores: this.scores }).then((res) => {
        this.outputScore = res.data.score;
      })
    }
  },

};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Comfortaa:wght@500&family=Montserrat&display=swap');


html,
body {
  background-color: #FFFCF2;
}

h1,
h2 {
  font-family: 'Comfortaa', cursive;
}

label {
  font-family: 'Montserrat', sans-serif;
}

.parent-div {
  border: 5px solid #403D39;
  border-radius: 25px;
}

.sub-score {
  font-family: 'Montserrat', sans-serif;
  font-size: large;
  outline-color: #403D39;
}

.btn-primary {
  background-color: #403D39;
}

.btn-primary:hover {
  background-color: #CCC5B9;
  color: #403D39;
}

.course-code {
  font-family: 'Montserrat', sans-serif;

}
</style>
